/* Lieferwahl im Warenkorb.
   Die Postleitzahl bestimmt das Gebiet, die Wiener Uhrzeit bestimmt,
   ob Same Day heute überhaupt noch geht. Die Wahl wird als Position
   in den Warenkorb gelegt, die Empfängerdaten als Bestellangaben. */
(function () {
  var wurzel = document.getElementById('korb-lieferung');
  if (!wurzel) return;

  var daten = JSON.parse(document.getElementById('kl-daten').textContent);
  var elZone = document.getElementById('kl-zone');
  var elArten = document.getElementById('kl-arten');
  var elWarnung = document.getElementById('kl-warnung');
  var elStatus = document.getElementById('kl-status');
  /* Alle sichtbaren Texte kommen aus den Sprachdateien ueber kl-daten,
     damit die englische, russische und ukrainische Fassung stimmen.
     Die Schluessel der Bestellangaben bleiben deutsch, sie landen im Auftrag. */
  var texte = daten.texte || {};

  var felder = {
    'Empfänger': document.getElementById('kl-name'),
    'Straße': document.getElementById('kl-strasse'),
    'PLZ': document.getElementById('kl-plz'),
    'Ort': document.getElementById('kl-ort')
  };

  function gebiet(plz) {
    if (!/^\d{4}$/.test(plz)) return null;
    var n = Number(plz);
    return (n >= 1010 && n <= 1239) ? 'Wien' : 'Umgebung';
  }

  function minutenJetzt() {
    var t = new Intl.DateTimeFormat('de-AT', {
      timeZone: 'Europe/Vienna', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var h = Number(t.find(function (x) { return x.type === 'hour'; }).value);
    var m = Number(t.find(function (x) { return x.type === 'minute'; }).value);
    return h * 60 + m;
  }

  /* Die Lieferart steckt im Metafeld der Variante, nicht im Titel: der Titel
     wird uebersetzt, das Metafeld nicht. Faellt eine Variante ohne Metafeld
     herein, wird der Titel als Notbehelf gelesen. */
  function artZu(v) {
    if (v && v.art) return v.art;
    var t = (v && v.titel ? v.titel : String(v)).split(' \u00b7 ')[0];
    return t === 'Standard' ? 'standard' : (t === 'Same Day' ? 'sameday' : 'express');
  }

  /* Heutiges Datum in Wiener Zeit, nicht in der Zeitzone des Besuchers.
     Jemand in Dubai soll denselben Tag sehen wie das Atelier. */
  function heuteWien() {
    var t = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short'
    }).formatToParts(new Date());
    function teil(n) { return t.find(function (x) { return x.type === n; }).value; }
    return {
      jahr: Number(teil('year')),
      monat: Number(teil('month')),
      tag: Number(teil('day')),
      sonntag: teil('weekday') === 'Sun'
    };
  }

  /* Ostersonntag nach der Gaußschen Osterformel (gregorianisch). Daran hängen
     Ostermontag, Christi Himmelfahrt, Pfingstmontag und Fronleichnam. */
  function ostersonntag(jahr) {
    var a = jahr % 19, b = Math.floor(jahr / 100), c = jahr % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31);
    var tag = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(jahr, monat - 1, tag));
  }

  /* Die 13 gesetzlichen Feiertage in Österreich, in allen Bundesländern gleich.
     Karfreitag ist seit 2019 KEINER, Silvester und der 24. Dezember auch nicht.
     Landesfeiertage wie der Leopolditag sind bewusst nicht dabei, sie sind
     keine arbeitsfreien Feiertage nach dem Arbeitsruhegesetz. */
  function istFeiertag(d) {
    var fest = ['1-1', '1-6', '5-1', '8-15', '10-26', '11-1', '12-8', '12-25', '12-26'];
    if (fest.indexOf(d.monat + '-' + d.tag) >= 0) return true;
    var o = ostersonntag(d.jahr);
    var beweglich = [1, 39, 50, 60].map(function (plus) {   // Ostermontag, Himmelfahrt, Pfingstmontag, Fronleichnam
      var x = new Date(o.getTime() + plus * 86400000);
      return (x.getUTCMonth() + 1) + '-' + x.getUTCDate();
    });
    return beweglich.indexOf(d.monat + '-' + d.tag) >= 0;
  }

  /* An Sonn- und Feiertagen liefern wir nur im Express. */
  var heute = heuteWien();
  var nurExpressHeute = heute.sonntag || istFeiertag(heute);

  function nochBuchbar(v) {
    var art = artZu(v);
    if (nurExpressHeute && art !== 'express') return false;
    var a = daten.arten[art];
    if (!a || a.grenze === null || a.grenze === undefined) return true;
    return minutenJetzt() < a.grenze;
  }

  /* Warum gesperrt: falscher Tag oder abgelaufene Uhrzeit. */
  function grundFuerSperre(v) {
    if (nurExpressHeute && artZu(v) !== 'express') return daten.nurExpress;
    return daten.vorbei;
  }

  function preis(cent) {
    var euro = Math.floor(cent / 100), rest = cent % 100;
    return euro + (rest ? ',' + String(rest).padStart(2, '0') : '') + ' €';
  }

  function passende(zone) {
    // Alle Lieferarten des Gebiets bleiben sichtbar. Abgelaufene werden nur
    // gesperrt, damit der Kunde sieht, was es grundsätzlich gibt.
    return daten.varianten.filter(function (v) {
      var z = v.zone || (/Umgebung/.test(v.titel) ? 'umland' : 'wien');
      return zone === 'Wien' ? z === 'wien' : z === 'umland';
    });
  }

  function zeichne() {
    var plz = felder['PLZ'].value.trim();
    var zone = gebiet(plz);
    if (!zone) {
      elZone.hidden = true; elArten.hidden = true; elWarnung.hidden = true;
      return;
    }
    elZone.hidden = false;
    elZone.textContent = zone === 'Wien' ? texte.zoneWien : texte.zoneUmland;
    elZone.className = 'kl-zone ' + (zone === 'Wien' ? 'wien' : 'umland');

    var liste = passende(zone);
    elArten.hidden = false;
    elArten.innerHTML = '';
    liste.forEach(function (v) {
      var art = artZu(v);
      var offen = nochBuchbar(v);
      var zeile = document.createElement('label');
      zeile.className = 'kl-art' + (offen ? '' : ' gesperrt');
      zeile.innerHTML =
        '<input type="radio" name="lieferart" value="' + v.id + '">' +
        '<span class="kl-art-text"><span class="kl-art-name"></span>' +
        '<span class="kl-art-zeile"></span></span>' +
        '<span class="kl-art-preis"></span>';
      var eintrag = daten.arten[art] || {};
      zeile.querySelector('.kl-art-name').textContent = eintrag.name || v.titel.split(' \u00b7 ')[0];
      var unterzeile = eintrag.zeile || '';
      zeile.querySelector('.kl-art-zeile').textContent =
        offen ? unterzeile : unterzeile + ' \u00b7 ' + grundFuerSperre(v);
      zeile.querySelector('.kl-art-preis').textContent = preis(v.cent);
      var feld = zeile.querySelector('input');
      if (!offen) { feld.disabled = true; zeile.setAttribute('aria-disabled', 'true'); }
      if (Number(wurzel.dataset.gewaehlt) === v.id) feld.checked = true;
      feld.addEventListener('change', function () { waehle(v.id); });
      elArten.append(zeile);
    });
    pruefeWarnung();
    if (typeof kassePruefen === 'function') kassePruefen();
  }

  function pruefeWarnung() {
    var gewaehlt = elArten.querySelector('input:checked');
    if (!gewaehlt) { elWarnung.hidden = true; return; }
    var v = daten.varianten.find(function (x) { return x.id === Number(gewaehlt.value); });
    elWarnung.hidden = !(v && artZu(v) === 'express');
  }

  function melde(text, fehler) {
    elStatus.textContent = text || '';
    elStatus.className = 'kl-status' + (fehler ? ' fehler' : '');
  }

  function angaben() {
    var a = {};
    Object.keys(felder).forEach(function (k) { a[k] = felder[k].value.trim(); });
    return a;
  }

  function waehle(variantenId) {
    melde(texte.wirdUebernommen);
    // zuerst eine bestehende Lieferposition entfernen
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (korb) {
        var alt = korb.items.filter(function (i) { return i.handle === wurzel.dataset.produkt; });
        var kette = Promise.resolve();
        alt.forEach(function (i) {
          kette = kette.then(function () {
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: i.key, quantity: 0 })
            });
          });
        });
        return kette;
      })
      .then(function () {
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantenId, quantity: 1 }] })
        });
      })
      .then(function () {
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: angaben() })
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function () { melde(texte.fehler, true); });
  }

  // Angaben beim Verlassen eines Feldes sichern
  Object.keys(felder).forEach(function (k) {
    felder[k].addEventListener('change', function () {
      if (k === 'PLZ') zeichne();
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: angaben() })
      });
    });
  });
  felder['PLZ'].addEventListener('input', zeichne);

  zeichne();

  /* Kasse erst freigeben, wenn Lieferart UND Empfängeradresse stehen.
     Die Produkte sind in Shopify nicht versandpflichtig, deshalb fragt die
     Kasse selbst nie nach einer Lieferadresse. Fehlt sie hier, kommt eine
     Bestellung ohne Zustelladresse herein. */
  var kasse = document.querySelector('button[name="checkout"]');
  var elFehlt = document.getElementById('kl-fehlt');

  function adresseSteht() {
    var a = angaben();
    return Boolean(a['Empfänger'] && a['Straße'] && /^\d{4}$/.test(a['PLZ']) && a['Ort']);
  }

  function kassePruefen() {
    if (!kasse) return;
    var lieferart = Number(wurzel.dataset.gewaehlt) > 0 ||
                    Boolean(elArten.querySelector('input:checked'));
    var adresse = adresseSteht();
    kasse.disabled = !(lieferart && adresse);
    kasse.title = !adresse ? texte.adresseFehlt : (!lieferart ? texte.erstLieferart : '');
    if (elFehlt) elFehlt.hidden = adresse;
  }

  Object.keys(felder).forEach(function (k) {
    felder[k].addEventListener('input', kassePruefen);
  });
  kassePruefen();
})();
